import React, { useEffect, useReducer, useState } from 'react';
import { IconButton, Button } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { editInRoomDiningAddOn, addInRoomDiningAddOn } from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { useDispatch } from 'react-redux';
import { formDataValidate } from '../../../../../utils/formUtils';
import { fetchAllInRoomDining } from '../../../servicesSlice';
import CustomCheckbox from '../../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import InfoIcon from '@mui/icons-material/Info';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@mui/material/Tooltip';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import KeyValuePairList from '../../../../../shared/key-value-pair-list/KeyValuePairList';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const CustomToolTip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'black',
  },
})(Tooltip);

const AddonsCreate = (props) => {
  const { toggleDrawer, addon, hotelId, restaurantId, showLoader = () => {} } = props;
  const [loading, setLoading] = useState(false);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const dispatch = useDispatch();
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    price: {
      value: 0,
      fieldName: 'Price',
      errors: {},
      validations: [],
      tab: 0,
    },
    status: {
      value: false,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  useEffect(() => {
    if (addon) {
      const currFields = { ...formData };
      currFields.code.value = addon.code;
      currFields.name.value = addon.name;
      currFields.price.value = addon?.priceInDecimal;
      currFields.status.value = addon.status;
      currFields.customAttributes.value = addon.customAttributes || [];

      setFormData(currFields);
    }
  }, [addon]);

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (hotelId) {
      if (validate()) {
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        try {
          dispatch(stepUpLoaderCount());
          toggleDrawer('', false, '');
          setLoading(true);
          const payload = {
            name: formData.name.value,
            code: formData.code.value,
            status: formData.status.value,
            hotelId,
            restaurantId,
            customAttributes: formData.customAttributes.value,
          };
          payload.price = parseInt(formData.price.value, 10) || 0;
          payload.priceInDecimal = parseFloat(formData.price.value) || 0;
          if (addon) {
            payload.id = addon.id;
            await editInRoomDiningAddOn(payload, language);
            notificationManager('success', 'Add-ons updated successfully');
          } else {
            await addInRoomDiningAddOn(payload, language);
            notificationManager('success', 'Add-ons created successfully');
          }
          dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        } catch (error) {
          if (error.graphQLErrors) {
            notificationManager('danger', error?.graphQLErrors?.[0]?.message);
          } else {
            addon
              ? notificationManager('danger', 'Failed to update Add-ons')
              : notificationManager('danger', 'Failed to create Add-ons');
          }
        } finally {
          dispatch(stepDownLoaderCount());
        }
        setLoading(false);
      }
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  useEffect(() => {
    const isValid = formDataValidate(formData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  return (
    <form onSubmit={handleSubmit} className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>{addon ? 'Edit Add-ons' : 'Add Add-ons'}</span>
          </div>
          <div className='col-md-6 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          <div className='row px-3 w-100 mt-4'>
            <div className='col-md-6'>
              <span className='page-title-secondary'>Details</span>
            </div>
          </div>
          <div className='row px-3 w-100 d-flex mt-3'>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData.name}
                  handleInputChange={(e) => {
                    setFormData({ name: e });
                  }}
                  maxLength={100}
                  endAdornment={true}
                  characterCount={true}
                  multiline={true}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData.code}
                  handleInputChange={(e) => {
                    setFormData({ code: e });
                  }}
                  maxLength={60}
                  endAdornment={true}
                  characterCount={true}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData.price}
                  handleInputChange={(e) => {
                    setFormData({ price: e });
                  }}
                  type='number'
                  min={0}
                  max={99999999}
                />
              </div>
            </div>
            <div className='px-3 mb-3 w-100 d-flex mt-2 align-items-center'>
              <div style={{ display: 'inline-flex', alignItems: 'center', flex: '0 0 auto' }}>
                <CustomCheckbox
                  item={formData.status}
                  handleInputChange={(e) => {
                    setFormData({ status: e });
                  }}
                  color='primary'
                />
              </div>
              <CustomToolTip
                title='Deactivating this, hides it from Guest app'
                placement='right-end'
              >
                <InfoIcon fontSize='small' className='mb-1' />
              </CustomToolTip>
            </div>
            <KeyValuePairList
              item={formData.customAttributes}
              onListChange={(e) => {
                setFormData({ customAttributes: e });
              }}
            />
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              variant='contained'
              type='submit'
              color='primary'
              className='me-3'
              size='large'
              disabled={loading || isTabInValid}
            >
              {addon ? 'Update' : 'Add'}
            </Button>
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {loading && <div className='pt-4 col-md-12'>{<LinearProgressBar />}</div>}
        </div>
      </div>
    </form>
  );
};

export default AddonsCreate;
